import I18n from 'lib/i18n/i18n';
import echarts from 'echarts';

export function getOption(props) {
    if (!props.priceData) {
        return {};
    }
    const centerStoneDarkColor = I18n.getString('itemPage::trends::priceOverTime::colors::darkCenterStone');
    const centerStoneLightColor = I18n.getString('itemPage::trends::priceOverTime::colors::lightCenterStone');
    const settingsDarkColor = I18n.getString('itemPage::trends::priceOverTime::colors::darkSettings');
    const settingsLightColor = I18n.getString('itemPage::trends::priceOverTime::colors::lightSettings');
    const smallDiamondsDarkColor = I18n.getString('itemPage::trends::priceOverTime::colors::darkSmallDiamonds');
    const smallDiamondsLightColor = I18n.getString('itemPage::trends::priceOverTime::colors::lightSmallDiamonds');
    const brandDarkColor = I18n.getString('itemPage::trends::priceOverTime::colors::darkBrand');
    const brandLightColor = I18n.getString('itemPage::trends::priceOverTime::colors::lightBrand');
    const graphSubsetsData = {
        'Ring': {darkColor: settingsDarkColor, LightColor: settingsLightColor, displayName: 'Setting'},
        'Minor Stone Batch': {
            darkColor: smallDiamondsDarkColor,
            LightColor: smallDiamondsLightColor,
            displayName: 'Small Diamonds'
        },
        'Side Stone Batch': {
            darkColor: smallDiamondsDarkColor,
            LightColor: smallDiamondsLightColor,
            displayName: 'Small Diamonds'
        },
        'Center Stone': {
            darkColor: centerStoneDarkColor,
            LightColor: centerStoneLightColor,
            displayName: 'Center Stone'
        },
        'Brand': {darkColor: brandDarkColor, LightColor: brandLightColor, displayName: 'Brand'}
    };

    let subsets = {};
    Object.keys(props.priceData).forEach(name => {
        let subsetData = graphSubsetsData[name];
        if (!subsetData) return;
        subsets[subsetData.displayName] = {
            baseColor: subsetData.darkColor,
            color: new echarts.graphic.LinearGradient(0, 0, 1.2, 0, [{
                offset: 0,
                color: subsetData.darkColor
            }, {
                offset: 1,
                color: subsetData.LightColor
            }]),
            data: props.priceData[name]
        }
    });

    const preOwned = I18n.getString('itemPage::trends::priceOverTime::preOwned');
    const yearAgo = preOwned + '\n' + I18n.getString('itemPage::trends::priceOverTime::yearAgo');
    const today = preOwned + '\n' + I18n.getString('itemPage::trends::priceOverTime::today');
    const inYear = preOwned + '\n' + I18n.getString('itemPage::trends::priceOverTime::inYear');
    const newVal = I18n.getString('itemPage::trends::priceOverTime::new');
    const was = I18n.getString('itemPage::trends::priceOverTime::was');
    const now = I18n.getString('itemPage::trends::priceOverTime::now');
    const projected = I18n.getString('itemPage::trends::priceOverTime::projected');

    let labels = [newVal, was, now, projected];

    let option = {
        legend: {
            data:
                Object.keys(subsets).reverse().map(subset => {
                    return {
                        name: subset,
                        icon: 'circle'
                    }
                }),
            left: 0,
            top: '11px',
            itemGap: 15,
            textStyle: {
                color: '#8c8c8c',
                fontSize: 14,
                fontWeight: 400,
            },
            selectedMode: false
        },
        grid: {
            left: '1%',
            right: '12%',
            bottom: '3%',
            top: '45%',
            containLabel: true
        },
        xAxis: [{
            type: 'category',
            boundaryGap: false,
            data: [{
                value: newVal,
                textStyle: {
                    align: 'left'
                }
            },
                yearAgo, today, inYear
            ],
            axisTick: {
                alignWithLabel: true,
                show: false
            },
            axisLabel: {
                fontWeight: 400,
                fontSize: 12,
            },
            axisLine: {
                show: false
            },
        }
        ],
        yAxis: [{
            boundaryGap: false,
            position: 'left',
            name: '$',
            type: 'value',
            nameTextStyle: {
                color: '#000000',
                fontSize: 14,
                fontWeight: 600
            },
            axisLabel: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: '#eeeeee'
                }
            },
            axisTick: {
                show: false
            },
            splitLine: {
                lineStyle: {
                    color: '#eeeeee'
                }
            }
        }],
        series: Object.keys(subsets).map((subset, i) => {
            let color = subsets[subset].color;
            let markLine = {};
            if (subset == 'Center Stone') {
                markLine = {
                    lineStyle: {
                        color: I18n.getString('itemPage::trends::priceOverTime::colors::lineStyle'),
                        width: 1,
                        type: 'dashed',
                        emphasis: {
                            width: 1,
                            type: 'dashed',
                        }
                    },
                    data:
                        subsets[subset].data.map((value, j) => {
                            let sum = Math.round(Object.keys(subsets).reduce((total, obj) => subsets[obj].data[j] + total, 0));
                            let sumText = sum.toLocaleString('en');
                            let graphHeight = props.priceData ? Object.keys(props.priceData).reduce((total, obj) => props.priceData[obj][0] + total, 0) : 0;
                            let height = props.priceData ? graphHeight / Object.keys(props.priceData).length : 0;
                            let styles;
                            let nowLabel = {};
                            if (j == 2) {
                                styles = {
                                    borderWidth: 3,
                                    borderColor: '#F5A623'
                                }
                                sumText = `${props.estRange.low.toLocaleString('en')} - \$${props.estRange.high.toLocaleString('en')}`
                            } else {
                                styles = {
                                    shadowBlur: 6,
                                    shadowOffsetX: 1,
                                    shadowOffsetY: 1,
                                    shadowColor: 'rgba(136, 135, 135, 0.5)'
                                }
                            }
                            let baseOptions = {
                                position: 'end',
                                show: true,
                                formatter: `{c|\$${sumText}\n}{b|${labels[j]}}`,
                                backgroundColor: 'white',
                                padding: [7, 2, 5, 2],
                                width: 130,
                                distance: 20,
                                height: 40,
                                rich: {
                                    b: {
                                        fontSize: 12,
                                        color: j == 2 ? '#000000' : '#b5b5b5',
                                        fontWeight: 400,
                                        height: 20
                                    },
                                    c: {
                                        height: 22,
                                        fontSize: 16,
                                        color: '#000000',
                                        fontWeight: j == 2 ? 'bolder' : 'bold'
                                    },
                                    x: {
                                        color: '#000000'
                                    }
                                }
                            }

                            if (j == 2) {
                                nowLabel = {
                                    markArea: {
                                        label: {
                                            align: 'center',
                                        }
                                    },
                                    label: {
                                        normal: {...baseOptions, ...styles}
                                    },
                                    coord: [j, sum]
                                }
                            }

                            return [nowLabel, {coord: [j, sum + height], symbol: 'none'}]
                        })
                }
            }
            return {
                hoverAnimation: false,
                legendHoverLink: false,
                name: subset,
                type: 'line',
                stack: 'price',
                color: subsets[subset].baseColor,
                areaStyle: {
                    color: color
                },
                data: subsets[subset].data,
                lineStyle: {
                    width: 0
                },
                symbol: 'none',
                markLine: markLine
            }
        })
    };
    return option;
}
